import * as tslib_1 from "tslib";
import selectAttachmentPreferencesOption from '../actions/selectAttachmentPreferencesOption';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';
var AttachmentPreferencesChoiceGroup = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentPreferencesChoiceGroup, _super);
    function AttachmentPreferencesChoiceGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectAttachmentPreferencesOption(_this.props.optionKey, parseInt(option.key, 10));
        };
        return _this;
    }
    AttachmentPreferencesChoiceGroup.prototype.render = function () {
        var _a = this.props, selectedKey = _a.selectedKey, label = _a.label;
        return (React.createElement(ChoiceGroup, { selectedKey: "" + selectedKey, label: label, options: [
                {
                    key: "" + 0 /* None */,
                    text: strings.options_attachmentPreferences_askOption,
                },
                {
                    key: "" + 2 /* Share */,
                    text: strings.options_attachmentPreferences_shareOption,
                },
                {
                    key: "" + 1 /* Attach */,
                    text: strings.options_attachmentPreferences_attachOption,
                },
            ], onChange: this.onChange }));
    };
    AttachmentPreferencesChoiceGroup = tslib_1.__decorate([
        observer
    ], AttachmentPreferencesChoiceGroup);
    return AttachmentPreferencesChoiceGroup;
}(React.Component));
export default AttachmentPreferencesChoiceGroup;
//# sourceMappingURL=AttachmentPreferencesChoiceGroup.js.map